import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "reactstrap";
import React, { useState, useEffect } from "react";

const useAudio = (url) => {
  const [audio, setAudio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);
  const toggle = () => setPlaying(!playing);

  useEffect(() => {
    playing ? audio.play() : audio.pause();
  },
    [playing]
  );



  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, []);

  return [playing, toggle];
};

export const Player = ({ url }) => {
  const [playing, toggle] = useAudio(url);
  return (
    <div>
      <Button outline color="primary" style={{ border: '0px' }} onClick={toggle}>{playing ? <FontAwesomeIcon icon={faPause}></FontAwesomeIcon> : <FontAwesomeIcon icon={faPlay}></FontAwesomeIcon>}</Button>
    </div>
  );
};



export function AudioPlayer({ url }) {
  const [isPlay, setIsPlay] = useState(false);
  let audio = new Audio(url);

  useEffect(() => {
    audio = new Audio(url);
    setIsPlay(false);
  }, [url]);

  useEffect(() => {
    audio.addEventListener('ended', () => setIsPlay(false));
    return () => {
      audio.removeEventListener('ended', () => setIsPlay(false));
    };
  }, []);

  const handleAudio = () => {

    if (!isPlay) {
      setIsPlay(true)
      audio.play()
    } else {
      setIsPlay(false)
      audio.pause()
    }

  }

  return (
    <>
      <Button outline color="primary" style={{ border: '0px' }} onClick={handleAudio}>{isPlay ? <FontAwesomeIcon icon={faPause}></FontAwesomeIcon> : <FontAwesomeIcon icon={faPlay}></FontAwesomeIcon>}</Button>
    </>
  );
}
;